import { useEffect, useState } from 'react';
import { array } from 'prop-types';
import { Redirect, useParams } from 'react-router';
import { useMutation } from '@tanstack/react-query';

import { useAuth, useShop } from 'app/context';
import { Content, Require } from 'common/components';
import { initializeOrder } from 'data/orders';
import useEnterOrder from '../useEnterOrder';

const StartOrder = ({ steps }) => {
  const { eventId } = useParams();
  const { customerId } = useAuth();

  const shop = useShop();
  const [ooId, setOoId] = useState();

  // console.log('<StartOrder>', { eventId, customerId, shop, ooId });

  // initialize order
  const { mutate: init, error } = useMutation(
    () =>
      initializeOrder({ customerId, eventId, boothNumber: shop.boothNumber }),
    { onSuccess: ({ orderId }) => setOoId(orderId) },
  );

  useEffect(() => {
    if (!ooId) {
      // get a new order id
      init();
    } else if (ooId !== shop.ooId) {
      // update `shop`
      shop.reset({ eventId, ooId });
    }
  }, [eventId, ooId, shop, init]);

  // get entry
  const entry = useEnterOrder(steps);

  return (
    <Require data={[eventId]}>
      {entry ? (
        <Redirect to={entry} />
      ) : (
        <Content error={error?.message} isLoading={!error} />
      )}
    </Require>
  );
};

StartOrder.propTypes = {
  step: array,
};

export default StartOrder;
